import { Injectable } from '@angular/core';
import { ApiLinks } from '@cutting/app.api-links';
import {
  BazisXHRClient,
  compileTemplate,
  createEvaluator,
  CuttingXHRClient,
  htmlToElement,
  ICuttingDocData,
  NgxLocalizedNumbersService,
} from 'cloud-shared-lib';
import * as _ from 'lodash';
import * as ts from 'typescript';

type BazisDocOptions = { invoiceId?: number; actId?: number };
type GenerationResult = { res: HTMLElement; error: any };

@Injectable({
  providedIn: 'root',
})
export class DocumentsService {
  constructor(private localizedNumbersService: NgxLocalizedNumbersService) {}

  async generateBazisDocument(
    script: string,
    schema: string,
    userId: number,
    presetData: BazisDocOptions = {}
  ): Promise<GenerationResult> {
    try {
      const jsCode = ts.transpile(script);
      const evaluator = createEvaluator({
        presetData: _.merge(presetData, { serverName: ApiLinks.docBuilderHost }),
        xhrClient: new BazisXHRClient(userId),
      });

      const codeRes = await evaluator(jsCode);

      if (codeRes && codeRes.error) {
        throw codeRes.error;
      }

      const element = htmlToElement(this.protectSchema(schema));
      if (await compileTemplate(element, codeRes)) {
        return { res: element, error: null };
      } else {
        return { res: null, error: 'Error' };
      }
    } catch (err) {
      console.log(err);
      return { res: null, error: err };
    }
  }

  async generateCuttingDoc(
    publicApiKey: string,
    script: string,
    orderId: number,
    schema: string
  ): Promise<GenerationResult> {
    try {
      const jsCode = ts.transpile(script);
      const evaluator = createEvaluator({
        presetData: {
          publicApiKey: publicApiKey,
          currency: this.localizedNumbersService.getCurrentLocaleDefinition().currency,
          serverName: ApiLinks.docBuilderHost,
        },
        xhrClient: new CuttingXHRClient(publicApiKey, orderId),
      } as ICuttingDocData);

      const codeRes = await evaluator(jsCode);

      if (codeRes && codeRes.error) {
        throw codeRes.error;
      }

      const element = htmlToElement(this.protectSchema(schema));
      if (await compileTemplate(element, codeRes)) {
        return { res: element, error: null };
      } else {
        return { res: null, error: 'Error' };
      }
    } catch (err) {
      console.log(err);
      return { res: null, error: err };
    }
  }

  private protectSchema(schema: string): string {
    return `<div>${schema}</div>`;
  }
}
